import {useEffect} from "react";
import {isProd} from "../../common/struct/globalVar";

export default function MatomoTracker(props: {initialized: boolean}): null {
  const {initialized} = props;
    
  useEffect(() => {
    if (initialized && isProd()) {
      loadMatomo();

      const _paq = (window as any)._paq;
      if (_paq) {
        _paq.push(['setConsentGiven']);
      }
    }
  }, [initialized]);
  
  return null;
}

export function loadMatomo(): void {
  if (typeof window === "undefined") return;
  
  const w = window as any;
  w._paq = w._paq || [];
  const _paq = w._paq;
  
  _paq.push(['requireConsent']);
  
  _paq.push(['setTrackerUrl', 'https://liberty.matomo.cloud/matomo.php']);
  _paq.push(['setSiteId', '2']);
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  
  const d = document;
  const g = d.createElement('script');
  g.async = true;
  g.src = 'https://cdn.matomo.cloud/liberty.matomo.cloud/matomo.js';
  
  const s = d.getElementsByTagName('script')[0];
  s?.parentNode?.insertBefore(g, s);
}